// eslint-disable-next-line import/prefer-default-export
export enum UserPreferencesBaseMap {
  DEFAULT = 'Default',
  SATELLITE = 'Satellite',
}
